function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10.131401mm",
    height: "10.85127mm",
    viewBox: "0 0 10.131401 10.85127",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.1483226,-24.635959)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: -0.93278712,
    cy: 31.436996,
    rx: 1.25,
    ry: 3.7500002,
    transform: "rotate(-10.779552)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: -17.070944,
    cy: 28.364443,
    rx: 1.25,
    ry: 3.7500002,
    transform: "matrix(-0.98235406,-0.18703074,-0.18703074,0.98235406,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.8,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: 26.285959,
    cy: -8.2374086,
    rx: 1.25,
    ry: 3.7500002,
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    cx: 8.2374086,
    cy: 34.237228,
    r: 0.75000054
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.6297aaeec917b19796027427fd22fb19.svg";
export { ForwardRef as ReactComponent };